import styled from 'styled-components';
import _ from 'lodash';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { topNavHeight, findFormByPathName } from '~utils/common.utils';
import { primaryColor } from '~theme';

import arrowSVG from '~images/ikoni_nuoli_vasen_valk.svg';

const getPageName = (location, navItems, isDesktop) => {
  const { pathname } = location;

  // Hard coded names for Webshop because why not
  const webshopBasePath = '/palvelut/tuotteet';
  if (_.startsWith(pathname, webshopBasePath)) {
    // Remove base path
    // example: /palvelut/tuotteet/cart/done -> /cart/done
    const webshopSubPath = pathname.slice(
      webshopBasePath.length,
      pathname.length
    );

    // Basically case ''
    if (!webshopSubPath || webshopSubPath === '/') {
      return {
        title: 'Tilaa tarvikkeita',
        link: `${isDesktop ? '' : `${webshopBasePath}/mobile`}`,
      };
    }

    // Remove anything that comes after
    // example: /cart/done -> cart
    const subPathParts = webshopSubPath.split('/').filter(e => e.length > 0);
    const subBase = subPathParts[0];

    switch (subBase) {
      case 'previous-orders':
        if (
          subPathParts.length === 1 ||
          (subPathParts.length === 2 && subPathParts[1] === 'done')
        ) {
          return {
            title: 'Aiemmat tilaukset',
            link: `${isDesktop ? '' : `${webshopBasePath}/mobile`}`,
          };
        }
        return {};
      case 'cart':
        return { title: 'Ostoskori', link: webshopBasePath };
      case 'products':
        return { title: 'Lisätiedot', link: webshopBasePath };
      case 'hierarchy':
        return { title: 'Tuoteryhmät', link: webshopBasePath };
      case 'mobile':
      default:
        return { title: 'Tarviketilaukset' };
    }
  }

  // Case projects
  const projectsBasePath = '/palvelut/projektit';
  if (_.startsWith(pathname, projectsBasePath)) {
    const projectsSubPath = pathname.slice(
      projectsBasePath.length,
      pathname.length
    );

    // Basically case ''
    if (!projectsSubPath || projectsSubPath === '/') {
      return {
        title: 'Miniprojektit',
        link: '/',
      };
    }

    // If we're inside a project
    if (projectsSubPath.match(/\/([0-9]+)/)) {
      return { title: 'Projekti', link: projectsBasePath };
    }
  }

  // Try to find form name from API data
  const form = findFormByPathName(pathname, navItems);
  if (form && form.title) return { title: form.title };

  return { title: '' };
};

const BreadCrumbs = ({ navItems, isDesktop }) => {
  const location = useLocation();
  const page = getPageName(location, navItems, isDesktop);
  const navigate = useNavigate();

  if (!page.title) return <div id="no-breadcrumb" />;

  return (
    <Wrapper>
      <Container onClick={() => navigate(page.link || '/')}>
        <InnerContainer className="container">
          <Arrow src={arrowSVG} />
          <Header>{page.title}</Header>
        </InnerContainer>
      </Container>
      <BreadCrumbsGap />
    </Wrapper>
  );
};

const Container = styled.div`
  background-color: ${primaryColor};
  color: white;
  position: absolute;
  top: ${topNavHeight}px;
  left: 0px;
  min-height: 80px;
  width: 100%;

  display: flex;
  align-items: center;

  cursor: pointer;
`;

const InnerContainer = styled.div`
  display: flex;
  align-items: center;

  padding-left: 15px;
`;

const Arrow = styled.img`
  height: 18px;
`;

const Wrapper = styled.div`
  // The breakpoint at which navigation doesn't become full screen
  @media (min-width: 992px) {
    display: none;
  }
`;

const Header = styled.h4`
  color: white;
  font-size: 23px;
  margin: 0 0 0 12px;
  font-weight: 400;
`;

const BreadCrumbsGap = styled.div`
  padding-bottom: ${topNavHeight}px;
`;

const mapStateToProps = state => ({
  navItems: state.reducer.navlist,
  isDesktop: state.reducer.isDesktop,
});

export default connect(mapStateToProps)(BreadCrumbs);
